import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { httpHeaders } from '../../../environments/httpHeaders';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
const apiURL = environment.apiUrl;
const headers = httpHeaders.headers;
export class TreatmentsService {
    constructor(_http) {
        this._http = _http;
        this.deletedFileName = new BehaviorSubject('');
        this.currentFileName = this.deletedFileName.asObservable();
    }
    onDeleteFileName(fileName) {
        this.deletedFileName.next(fileName);
    }
    getDoctors() {
        const endPoint = '/api/admin/byrole/DO';
        return this._http.get(apiURL + endPoint, { headers: headers }).pipe(map((resp) => {
            return resp;
        }));
    }
    getTreatments(request) {
        this.previousResponse = [];
        const endPoint = '/api/treatment/search';
        request = this.escapeRequestProp(request);
        return this._http.post(`${apiURL}${endPoint}`, request, { headers: headers }).pipe(map((response) => {
            this.previousResponse = response;
            this.previousRequestParams = request;
            return response;
        }));
    }
    updateAssignedUser(idTreatment, idAdmin) {
        this.previousResponse = [];
        const endPoint = `/api/Treatment/TakeInCharge/${idTreatment}/${idAdmin}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    updateFaceScanData(data) {
        this.previousResponse = [];
        const endPoint = `/api/Treatment/UpdateFaceScanData/`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    updateOptSmartData(data) {
        this.previousResponse = [];
        const endPoint = `/api/Treatment/UpdateOptSmartData/`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    downloadFaceScanZip(data) {
        this.previousResponse = [];
        const endPoint = `/api/Storage/zip`;
        return this._http.post(`${apiURL}${endPoint}`, data, { observe: 'response', responseType: 'blob' });
    }
    downloadSmartOptionZip(data) {
        this.previousResponse = [];
        const endPoint = `/api/Storage/zip`;
        return this._http.post(`${apiURL}${endPoint}`, data, { observe: 'response', responseType: 'blob' });
    }
    updateSegmentationUser(idTreatment, idAdmin) {
        this.previousResponse = [];
        const endPoint = `/api/Treatment/SetSegmentationUser/${idTreatment}/${idAdmin}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    updateExportUser(idTreatment, idAdmin) {
        this.previousResponse = [];
        const endPoint = `/api/Treatment/SetExportUser/${idTreatment}/${idAdmin}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    updateCutUser(idTreatment, idAdmin) {
        this.previousResponse = [];
        const endPoint = `/api/Treatment/SetCutUser/${idTreatment}/${idAdmin}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    setCutFlag(idTreatment, value) {
        const endPoint = `/api/Treatment/SetCutFlag/${idTreatment}/${value}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    setExportFlag(idTreatment) {
        const endPoint = `/api/Treatment/SetExportFlag/${idTreatment}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    helpMeOut(body) {
        const endPoint = `/api/treatment/ChangeStatus/HelpMeOut`;
        return this._http.post(`${apiURL}${endPoint}`, body, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    updateCloudType(body) {
        const endPoint = `/api/Treatment/UpdateCloudType`;
        return this._http.post(`${apiURL}${endPoint}`, body, { headers: headers });
    }
    getHistory(treatmentId) {
        this.previousResponse = [];
        const endPoint = '/api/treatment/log/' + treatmentId;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    getTreatment(treatmentId) {
        const endPoint = `/api/treatment/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    getTreatmentFiles(treatmentId) {
        const endPoint = `//api/Storage/GetTreatmentFiles/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    uploadTreatmentFile(file, containerName) {
        const endPoint = '/api/storage';
        const formData = new FormData();
        formData.append('fileObject', file, file.name);
        formData.append('containerName', containerName);
        formData.append('createContainerIfNotExists', 'true');
        return this._http.put(apiURL + endPoint, formData).pipe(map((resp) => {
            return resp;
        }));
    }
    getTreatmentsReport(request) {
        const endPoint = '/api/treatment/report';
        return this._http.post(`${apiURL}${endPoint}`, request, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    moveTreatmentToBasket(request) {
        const endPoint = '/api/treatment/movetobasket/';
        return this._http.post(`${apiURL}${endPoint}`, request, { headers: headers }).pipe(map((response) => {
            return response;
        }));
    }
    existByIdAddress(idAddress) {
        const endPoint = `/api/treatment/existsByIdAddrress/${idAddress}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    escapeRequestProp(request) {
        for (const prop in request) {
            if (typeof (request[prop]) !== 'number') {
                if (!request[prop] && prop !== 'ignoreArchived') {
                    delete (request[prop]);
                }
            }
        }
        return request;
    }
    getPreviousReponse() {
        if (!this.previousResponse) {
            this.previousResponse = [];
        }
        return this.previousResponse;
    }
    getPreviousRequest() {
        return this.previousRequestParams;
    }
    reset() {
        this.previousRequestParams = null;
        this.previousResponse = [];
        this.filterParam = '';
    }
    setFilterParams(val) {
        this.filterParam = val;
    }
    getFilterParams() {
        return this.filterParam ? this.filterParam : '';
    }
    changeStatus(reason, treatmentId, endpoint, request) {
        const endPoint = `/api/treatment/changestatus/${endpoint}`;
        request = request ? request : {
            idTreatment: +treatmentId,
            reason: reason
        };
        return this._http.post(`${apiURL}${endPoint}`, request, { headers: headers });
    }
    removeFromWaiting(treatmentId) {
        const endPoint = `/api/treatment/RemoveFromWaitingFor/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    closeChat(treatmentId) {
        const endPoint = `/api/treatment/chat/closechat/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    takeInCharge(idTreatment, idAdmin) {
        const endPoint = `/api/treatment/takeincharge/${idTreatment}/${idAdmin}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    closeChatIncomplete(treatmentId) {
        const endPoint = `/api/treatment/incomplete/chat/closechat/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    setTreatmentPlan(plan) {
        const endPoint = `/api/treatmentplan`;
        return this._http.post(`${apiURL}${endPoint}`, plan, { headers: headers });
    }
    createTreatmentPlanPDF(body, idTreatment, language) {
        const endPoint = `/api/treatmentplan/createpdf/${idTreatment}/${language}`;
        return this._http.post(`${apiURL}${endPoint}`, body, { headers: headers });
    }
    getTreatmentPlanById(treatmentId) {
        const endPoint = `/api/treatmentplan/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    goToNext(idTreatment, value) {
        const endPoint = `/api/treatmentplan/gotonext/${idTreatment}/${value}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    saveAdminData(treatmentId, request) {
        const endPoint = `/api/Treatmentplan/administrationdata/${treatmentId}`;
        return this._http.post(`${apiURL}${endPoint}`, request, { headers: headers });
    }
    getScheduleTimes(arg0) {
        const endPoint = `/api/Treatment/PickupDates/${arg0}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    putScheduleTime(request) {
        const endPoint = `/api/Treatment/PickupDate`;
        return this._http.post(`${apiURL}${endPoint}`, request, { headers: headers });
    }
    addAdditionalRequest_newPrint(req) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest/NewPrint`;
        return this._http.post(`${apiURL}${endPoint}`, req, { headers: headers });
    }
    addAdditionalRequest_newRetainers(req) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest/NewRetainers`;
        return this._http.post(`${apiURL}${endPoint}`, req, { headers: headers });
    }
    addAdditionalRequest_reMake(req) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest/Remake`;
        return this._http.post(`${apiURL}${endPoint}`, req, { headers: headers });
    }
    addAdditionalRequest_newFreedom(req) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest/NewFreedom`;
        return this._http.post(`${apiURL}${endPoint}`, req, { headers: headers });
    }
    addAdditionalRequest_newIntercept(req) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest/NewIntercept`;
        return this._http.post(`${apiURL}${endPoint}`, req, { headers: headers });
    }
    addAdditionalRequest_updateStatus(req) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest`;
        return this._http.put(`${apiURL}${endPoint}`, req, { headers: headers });
    }
    addAdditionalRequest_delete(idrequest) {
        const endPoint = `/api/TreatmentPlan/AdditionalRequest`;
        return this._http.delete(`${apiURL}${endPoint}/` + idrequest, { headers: headers });
    }
    updateWebViewerFile(data) {
        const endPoint = `/api/treatment/updatewebviewerfile`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers });
    }
    deleteWebViewer(treatmentId) {
        const endPoint = `/api/treatment/deletewebviewer/${treatmentId}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    updateAddresses(data) {
        const endPoint = `/api/treatment/updateaddresses`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers });
    }
    changeDoctor(data) {
        const endPoint = `/api/treatment/movedoctor`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers });
    }
    cloneTreatment(data) {
        const endPoint = `/api/treatment/clone`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers });
    }
    cloneTellMeYes(data) {
        const endPoint = `/api/TellMeYes/clone`;
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers });
    }
    getDoctorHistory(idTreatment) {
        const endPoint = `/api/Treatment/MoveDoctor/Log/${idTreatment}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    generateTreatmentCode(treatmentId, archesType) {
        const endPoint = `/api/treatment/generatetreatmentcode/${treatmentId}/${archesType}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    updatePatientAdditionalNotes(idTreatment, treatmentCode, notes) {
        const endPoint = `/api/treatment/updatepatientnotes`;
        const data = {
            'idtreatment': +idTreatment,
            'treatmentCode': treatmentCode,
            'patientAdditionalNotes': notes
        };
        return this._http.post(`${apiURL}${endPoint}`, data, { headers: headers });
    }
    updateTreatmentPlanNotes(body) {
        const endPoint = `/api/treatmentplan/UpdateTreatmentPlanNotes`;
        return this._http.post(`${apiURL}${endPoint}`, body, { headers: headers });
    }
    updateClinicPreferenceFlag(idDoctor) {
        const endPoint = `/api/admin/doctor/clinicprefflag/${idDoctor}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
    updatePlannedShippingDate(body) {
        const endPoint = `/api/treatment/updateplannedshippingdate`;
        return this._http.post(`${apiURL}${endPoint}`, body, { headers: headers });
    }
    removePlannedShippingDate(body) {
        const endPoint = `/api/treatment/DeletePlannedShippingDate/`;
        return this._http.get(`${apiURL}${endPoint}${body.idTreatment}`, { headers: headers });
    }
    sendChatNotification(idTreatment) {
        const endPoint = `/api/treatment/sendchatnotification/${idTreatment}`;
        return this._http.get(`${apiURL}${endPoint}`, { headers: headers });
    }
}
TreatmentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TreatmentsService_Factory() { return new TreatmentsService(i0.ɵɵinject(i1.HttpClient)); }, token: TreatmentsService, providedIn: "root" });
